import React from "react"

const WaitlistModalContext = React.createContext({
  isOpen: false,
  handleOpen: () => {},
  handleClose: () => {}
});

export const WaitlistModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleOpen = () => (
    setIsOpen(true)
  )

  const handleClose = () => (
    setIsOpen(false)
  )

  return (
    <WaitlistModalContext.Provider value={{ isOpen, handleOpen, handleClose }}>
      {children}
    </WaitlistModalContext.Provider>
  );
}

export const WaitlistModalConsumer = WaitlistModalContext.Consumer;
